import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import Shimmer from './components/Common/Shimmer';

// Lazy loading pages
const Home = lazy(() => import('./pages/Home'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const PrivacyCoinApp = lazy(() => import('./pages/PrivacyCoinApp'));
const PrivacyInsectApp = lazy(() => import('./pages/PrivacyInsectApp'));
const PrivacyRamadanApp = lazy(() => import('./pages/PrivacyRamadanApp'));
const PrivacyScreenMirrorApp = lazy(() => import('./pages/PrivacyScreenMirrorApp'));
const PrivacyGoPlantApp = lazy(() => import('./pages/PrivacyGoPlantApp'));
const PrivacyTasklyApp = lazy(() => import('./pages/PrivacyTasklyApp'));
const PrivacyHijriCalendarApp = lazy(() => import('./pages/PrivacyHijriCalendarApp'));
const PrivacyGpsStampCameraApp = lazy(() => import('./pages/PrivacyGpsStampCameraApp'));
const PrivacyAINotesApp = lazy(() => import('./pages/PrivacyAINotesApp'));
const PrivacyVideoCompressorApp = lazy(() => import('./pages/PrivacyVideoCompressorApp'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));
const TermsAndConditionsOfService = lazy(() => import('./pages/TermsAndConditionsOfService'));
const SubscriptionTerms = lazy(() => import('./pages/SubscriptionTerms'));
const SubscriptionTermsVideoCompressorApp = lazy(() => import('./pages/SubscriptionTermsVideoCompressorApp'));
const TermsOfUseIslamPro = lazy(() => import('./pages/TermsOfUseIslamPro'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const OpenApp = lazy(() => import('./pages/OpenApp'));
const NotFound = lazy(() => import('./pages/NotFound'));


function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="app">
          <Navbar />
          <Suspense fallback={<Shimmer type="home" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/privacy-policy-coin-app" element={<PrivacyCoinApp />} />
              <Route path="/privacy-policy-insect_identifier-app" element={<PrivacyInsectApp />} />
              <Route path="/ramadancalendar-privacypolicy" element={<PrivacyRamadanApp />} />
              <Route path="/screenmirroring-privacy-policy" element={<PrivacyScreenMirrorApp />} />
              <Route path="/goplant-privacy-policy" element={<PrivacyGoPlantApp />} />
              <Route path="/privacy-policy-to-do-list-task-manager" element={<PrivacyTasklyApp />} />
              <Route path="/hijri-calendar-privacy-policy" element={<PrivacyHijriCalendarApp />} />
              <Route path="/gps-stamp-camera-privacy-policy" element={<PrivacyGpsStampCameraApp />} />
              <Route path="/gps-stamp-camera-privacy-policy/" element={<PrivacyGpsStampCameraApp />} />
              <Route path="/privacy-policy-ai-note-taker" element={<PrivacyAINotesApp />} />
              <Route path="/privacy-policy-ai-note-taker/" element={<PrivacyAINotesApp />} />
              <Route path="/privacy-policy-video-compressor" element={<PrivacyVideoCompressorApp />} />
              <Route path="/privacy-policy-video-compressor/" element={<PrivacyVideoCompressorApp />} />
              <Route path="/subscription-terms-video-compressor" element={<SubscriptionTermsVideoCompressorApp />} />
              <Route path="/subscription-terms-video-compressor/" element={<SubscriptionTermsVideoCompressorApp />} />
              <Route path="/terms" element={<TermsConditions />} />
              <Route path="/terms-and-conditions-of-service" element={<TermsAndConditionsOfService />} />
              <Route path="/subscription-terms-for-goplant" element={<SubscriptionTerms />} />
              <Route path="/subscription-terms-for-goplant/" element={<SubscriptionTerms />} />
              <Route path="/subscription-terms" element={<SubscriptionTerms />} />
              <Route path="/terms-of-use-eula" element={<TermsOfUseIslamPro />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/splashScreen/" element={<OpenApp />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
